export const menuPortalTarget = typeof window !== 'undefined' ? document.getElementById('__next') : null;
